import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import AddressFields from 'react/shared/components/true_link/lab/form/address_input/AddressFields';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import addressShape from 'react/signups/card/shapes/AddressShape';

const useStyles = makeStyles(() => ({
  buttonPosition: {
    margin: '1rem 1rem 0 -.5rem',
    position: 'inherit',
  },
}));

export default function AddressForm({
  onContinue,
  setFieldTouched,
  showPoBoxWarning,
  setValues,
  values,
}) {
  const classes = useStyles();

  return (
    <>
      <AddressFields
        setFieldTouched={setFieldTouched}
        setValues={setValues}
        showPoBoxWarning={showPoBoxWarning}
        values={values}
      />
      <NextPageButton className={classes.buttonPosition} label="Done" onClick={onContinue} />
    </>
  );
}

AddressForm.propTypes = {
  onContinue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  showPoBoxWarning: PropTypes.bool,
  values: PropTypes.shape({
    address: addressShape.isRequired,
  }).isRequired,
};
